module.exports = __webpack_public_path__ + "img/emoticon-nps-8-off.64f470b4.svg";